import serviceTypeStore from './serviceTypeStore';

export default {
  install(store) {
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base.serviceTypeOption) {
      store.registerModule(['base', 'serviceTypeOption'], serviceTypeStore);
    }
  },
  uninstall(store) {
    store.unregisterModule(['base', 'serviceTypeOption']);
  },
};
